import React from 'react';
import classnames from 'classnames';
import { H5, SecondaryBody } from 'scy/text';
import { sansSerifBlack, fontSizeS } from 'scy/text/styles.mod.scss';
import { localizeNumber } from 'shared/utils';
import { tablet_maxWidth50, right, boxShadow } from 'scy/utils.mod.scss';
import { borderRadius } from 'scy/border.mod.scss';
import { hidden, tablet_block, block } from 'scy/display.mod.scss';
import { flex, flex1, centerContent, column } from 'scy/flex.mod.scss';
import { BUTTON_CLASSES } from 'scy/buttons';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';

export default function LoyaltyOfferCards({ offers }) {
  const [first, second] = offers;
  if (!first) return null;

  return (
    <div
      className={classnames(
        padding.left_sm,
        padding.right_sm,
        margin.bottom_md,
        flex,
        centerContent
      )}
    >
      <OfferCard
        offer={first}
        className={classnames(flex1, tablet_maxWidth50)}
      />
      {!!second && (
        <OfferCard
          offer={second}
          className={classnames(hidden, tablet_block, flex1, margin.left_sm)}
        />
      )}
    </div>
  );
}

function OfferCard({ offer, className }) {
  const { title, description, link, call_to_action } = offer;
  const points = localizeNumber(offer.points);

  return (
    <section
      className={classnames(
        className,
        boxShadow,
        padding.sm,
        borderRadius,
        flex,
        column
      )}
    >
      <div className={margin.bottom_xs}>
        <H5 tag="h2" className={right}>
          +{points}
        </H5>
        <h1 className={classnames(margin.all0, sansSerifBlack, fontSizeS)}>
          {title}
        </h1>
      </div>
      <SecondaryBody
        marginClass={classnames(margin.top_0, margin.bottom_sm)}
        className={flex1}
      >
        {description}
      </SecondaryBody>
      {!!link && !!call_to_action && (
        <a
          href={link}
          className={classnames(
            BUTTON_CLASSES.primary,
            block,
            margin.left_sm,
            margin.right_sm
          )}
        >
          {call_to_action}
        </a>
      )}
    </section>
  );
}
